type Props = {
  clientName: string;
  avatarUrl?: string | null;
  online?: boolean;
  unreadCount?: number;
  onOpenChat: () => void;
};

function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function ClientChatTrigger({
  clientName,
  avatarUrl,
  online = false,
  unreadCount = 0,
  onOpenChat,
}: Props) {
  const initials = clientName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2 rounded-full border border-[#EAECF0] bg-white px-2.5 py-1.5 shadow-[0_1px_2px_rgba(16,24,40,0.06)]">
        <div className="relative">
          <div className="h-8 w-8 overflow-hidden rounded-full border border-[#EAECF0] bg-white">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={clientName}
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="grid h-full w-full place-items-center text-xs font-semibold text-[#344054]">
                {initials || "C"}
              </div>
            )}
          </div>
          <span
            className={cn(
              "absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full border-2 border-white",
              online ? "bg-[#12B76A]" : "bg-[#98A2B3]",
            )}
          />
        </div>

        <div className="max-w-[160px] truncate text-sm font-semibold text-[#101828]">
          {clientName}
        </div>
      </div>

      <button
        type="button"
        onClick={onOpenChat}
        className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#EAECF0] bg-white shadow-[0_1px_2px_rgba(16,24,40,0.06)] hover:bg-[#F9FAFB] focus:outline-none focus:ring-2 focus:ring-[#D0D5DD]"
        aria-label="Open messages"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z"
            stroke="#344054"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>

        {unreadCount > 0 ? (
          <span className="absolute -right-1 -top-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#F04438] px-1 text-[11px] font-semibold text-white">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        ) : null}
      </button>
    </div>
  );
}
